import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import Navbar from '../components/Navbar';
import { EPaymentType } from '../store/layout.slice';

function Return() {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');

    return (
        <div>
            {/* <Navbar page="translate"/> */}
            <div className='anim-fade-in mt-8 max-w-5xl mx-auto pt-4 md:pt-10 px-5'>
                {/* <h3 className='text-4xl md:text-5xl font-bold tracking-wide mb-1 md:mb-2 text-center'>Translate Subtitle</h3>
                <p className='text-2xl mb-20 md:mb-40 text-gray-700 text-center'>Translate your subtitles into desired languages.</p> */ }
                <div className='flex justify-center items-center'>
                    <div className="w-full rounded-lg overflow-hidden shadow-lg px-6 py-6 max-w-xl">
                        <p className='text-center text-7xl text-green-700 mb-5'><i className="fa-solid fa-circle-check"></i></p>
                        <p className='text-center text-xl'>We've received your payment!</p>
                        { type == EPaymentType.Translate && <>
                            <p className='text-center text-gray-700 mb-5'>Translation will soon start and you'll receive an email when it's done :)</p>
                            <div className='flex justify-center items-center'>
                                <Link to={`/translate`} className='btn btn-black'>Translate another subtitle</Link>
                            </div>
                        </> }
                        { type == EPaymentType.Convert && <>
                            <p className='text-center text-gray-700 mb-5'>Convert will soon start and you'll receive an email when it's done :)</p>
                            <div className='flex justify-center items-center'>
                                <Link to={`/convert`} className='btn btn-black'>Convert another file</Link>
                            </div>
                        </> }
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default React.memo(Return);